export enum AdminUserEmails {
  ADMIN_SUPPORT = "infra@rastrin.com"
}
